module.exports = __webpack_public_path__ + "static/media/accHomeMgr.a003b731.svg";